
export enum ExpressionType {
    SubstanceAdministrationPrescription = "SubstanceAdministrationPrescription"
}

export enum AggressorFilter {
    MedicSubstance = "MedicSubstance",
    MedicVaccine = "MedicVaccine"
}